export {
  getG2Review,
  setG2Review,
  updateG2ReviewStatus,
  type UpdateG2Review,
} from './action'

export const PartnerG2ReviewActionTypes = {
  SET_G2_REVIEW: 'SET_G2_REVIEW',
} as const
